import { render, staticRenderFns } from "./BindCashApp.vue?vue&type=template&id=190edd37&scoped=true&"
import script from "./BindCashApp.vue?vue&type=script&lang=js&"
export * from "./BindCashApp.vue?vue&type=script&lang=js&"
import style0 from "./BindCashApp.vue?vue&type=style&index=0&id=190edd37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190edd37",
  null
  
)

export default component.exports